(function () {
  'use strict';

  function newAddressFactory () {
    const factory = {};

    const householdTypes = [
      {
        'selected': false,
        'modelKey': 'all',
        'btnLabel': 'ALL',
        'info': 'ALL'

      }, {
        'selected': false,
        'modelKey': 'youth',
        'btnLabel': 'YOUTH',
        'info': 'NEW_ADDRESS_PAGE_YOUTH_INFO'
      }, {
        'selected': false,
        'modelKey': 'single',
        'btnLabel': 'SINGLE',
        'info': 'NEW_ADDRESS_PAGE_SINGLE_INFO'
      }, {
        'selected': false,
        'modelKey': 'couple',
        'btnLabel': 'NEW_ADDRESS_PAGE_COUPLE_CHILDREN',
        'info': 'NEW_ADDRESS_PAGE_COUPLE_CHILDREN_INFO'
      }, {
        'selected': false,
        'modelKey': 'familyChildren',
        'btnLabel': 'NEW_ADDRESS_PAGE_FAMILY_YOUNG_CHILDREN',
        'info': 'NEW_ADDRESS_PAGE_FAMILY_YOUNG_CHILDREN_INFO'
      }, {
        'selected': false,
        'modelKey': 'familyYouth',
        'btnLabel': 'NEW_ADDRESS_PAGE_FAMILY_YOUTH_HOME',
        'info': 'NEW_ADDRESS_PAGE_FAMILY_YOUTH_HOME_INFO'
      }, {
        'selected': false,
        'modelKey': 'establishedFamily',
        'btnLabel': 'NEW_ADDRESS_PAGE_ESTABLISHED_FAMILY',
        'info': 'NEW_ADDRESS_PAGE_ESTABLISHED_FAMILY_INFO'
      }, {
        'selected': false,
        'modelKey': 'middle-aged',
        'btnLabel': 'MIDDLE-AGED',
        'info': 'NEW_ADDRESS_PAGE_MIDDLE-AGE_INFO'
      }, {
        'selected': false,
        'modelKey': 'senior',
        'btnLabel': 'SENIORS',
        'info': 'NEW_ADDRESS_PAGE_SENIOR_INFO'
      } ];

    const lodging = [ {
      'selected': false,
      'modelKey': 'all',
      'btnLabel': 'ALL'
    }, {
      'selected': false,
      'modelKey': 'villa',
      'btnLabel': 'VILLA'
    }, {
      'selected': false,
      'modelKey': 'tenant',
      'btnLabel': 'TENANT'
    }, {
      'selected': false,
      'modelKey': 'other',
      'btnLabel': 'OTHER'
    } ];

    factory.householdTypes = householdTypes;
    factory.lodging = lodging;

    return factory;
  }

  angular.module('web2print.newAddress')
    .factory('newAddressFactory', newAddressFactory);
})();
